
import { Vue, Component, Prop } from 'vue-property-decorator';
import '@/assets/icon/font-awesome-4.7.0/css/font-awesome.min.css';

@Component
export default class TIcon extends Vue {
  @Prop({
    type: String,
    required: true,
    default: '',
  }) name!: string
}
